export default __webpack_public_path__ + "static/0077-5655445ed745d14d99c829bbba33b4f0.png";